const translationMixin = {
    props: {
        translations: {
            type: Object,
            default: () => {
                return {};
            }
        }
    }
};

export default translationMixin;
